<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>
          {{ $t('wxInvite.wx') }}
          <span v-if="lang == 'zh'">{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</span>
          <div v-else class="remark">{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</div>
        </h3>
      </div>

      <div class="main">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('wxInvite.enInvite')" name="first">
            <Cninvitation></Cninvitation>
          </el-tab-pane>

          <el-tab-pane label="Invitation (English)" name="second">
            <Eninvitation></Eninvitation>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import Cninvitation from './invitation/Cninvitation';
import Eninvitation from './invitation/Eninvitation.vue';
import MobileHead from '../../comment/mobile/mobileHead.vue';

export default {
  name: 'wxInvite',
  components: {
    Cninvitation,
    Eninvitation,
    MobileHead,
  },
  methods: {
    //切换标签页
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },

  data() {
    return {
      activeName: 'first', //标签页
      lang: '',
    };
  },
  created() {
    this.lang = localStorage.getItem('lang');
  },
};
</script>

<style lang="scss" scoped>
.tishi {
  font-size: 12px;
}
.body {
  font-family: PingFangSC-Regular, PingFang SC;
  padding: 10px;
  background: #f0f2f5;
  .header {
    padding: 0 0 17px 2px;

    h3 {
      font-size: 5.3vw;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
      .remark {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }
}
.content {
  display: flex;
  align-items: center;

  .left {
    .downloadposter {
      width: 1200px;
      height: 2640px;
      background: url('../../../static/wxBG.png') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding-top: 388px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 58px;
      color: #fffefe;
      line-height: 58px;

      .logoIMG {
        margin: 0 auto;
        max-width: 1000px;
        max-height: 340px;

        img {
          max-width: 1000px;
          max-height: 340px;
        }
      }

      .logo {
        margin: 0 auto;
        background: #ffffff;
        width: 1000px;
        height: 340px;
        color: #b9b9b9;
        text-align: center;
        line-height: 340px;
        font-size: 100px;
      }

      //二维码样式
      .qrcode {
        margin-top: 90px;
        display: inline-block;

        ::v-deep img {
          background-color: #fff; //设置白色背景色
          padding: 15px; // 利用padding的特性，挤出白边
          box-sizing: border-box;
        }
      }
    }

    //页面上的邀请函样式
    .poster {
      width: 310px;
      height: 690px;
      background: url('../../../static/wxBG.png') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding-top: 100px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #fffefe;

      .logoIMG {
        margin: 0 auto;
        max-width: 250px;
        max-height: 100px;

        img {
          max-width: 250px;
          max-height: 100px;
        }
      }

      .logo {
        margin: 0 auto;
        background: #ffffff;
        width: 250px;
        height: 100px;
        color: #b9b9b9;
        text-align: center;
        line-height: 100px;
        font-size: 28px;
      }

      //二维码样式
      .qrcode {
        margin-top: 20px;
        display: inline-block;

        ::v-deep img {
          background-color: #fff; //设置白色背景色
          padding: 3px; // 利用padding的特性，挤出白边
          box-sizing: border-box;
        }
      }

      div {
        p {
          margin-top: 13px;
        }
      }
    }
  }

  .right {
    margin-left: 102px;
    //提交前右侧样式
    .upload-logo {
      width: 350px;
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      img {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }

    //提交后右侧样式
    .submited {
      margin-left: 30px;

      p {
        margin-top: 20px;
      }

      .qrcode2 {
        margin: 39px 0 49px;
      }
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 10px;
}
/* 
>>> #tab-first {
  padding-left: 30px;
}

>>> .el-button {
  background-color: #006FB8;
  color: #FFFFFF;
  width: 88px;
  height: 32px;
  padding: 0;
  font-weight: 400;
}

>>> .upload.el-button {
  background-color: #FFFFFF;
  color: #666666;
  width: 102px;
}

>>> .submited .el-button {
  width: 102px;
}

>>> .submited .clear.el-button {
  background-color: #FDC400;
  margin-right: 20px;
} */
</style>
